export const JSON_SHOPPING = `
{
  "name": "Shopping Cart",
  "types": [
    {
      "id": 100,
      "supertype": "uievent",
      "name": "Go Shopping Clicked"
    },
    {
      "id": 101,
      "supertype": "uievent",
      "name": "Secondary Button Clicked",
      "attributes": [
        {
          "name": "Click Target",
          "type": "CartButtonClickTarget"
        }
      ]
    },
    {
      "id": 105,
      "supertype": "uievent",
      "name": "Clear Cart Clicked"
    },
    {
      "id": 106,
      "supertype": "uievent",
      "name": "Delete Product Clicked",
      "attributes": [
        {
          "name": "Product",
          "type": "Product"
        }
      ]
    },
    {
      "id": 107,
      "supertype": "uievent",
      "name": "Shop Info Link Clicked",
      "attributes": [
        {
          "name": "Shop Host as Id",
          "type": "String"
        },
        {
          "name": "Link Type",
          "type": "[TC, PRIVACY, SHIPPING]"
        }
      ]
    },
    {
      "id": 108,
      "supertype": "uievent",
      "name": "Product Remove Clicked",
      "attributes": [
        {
          "name": "Product Id",
          "type": "Number"
        }
      ]
    },
    {
      "id": 109,
      "supertype": "uievent",
      "name": "Product Quantity Changed",
      "attributes": [
        {
          "name": "Product Id",
          "type": "Number"
        },
        {
          "name": "ChangeType",
          "type": "[INC, DEC]"
        }
      ]
    },
    {
      "id": 110,
      "supertype": "uievent",
      "name": "Checkout Button Clicked"
    },
    {
      "id": 111,
      "supertype": "uievent",
      "name": "Screen brought to front"
    }
  ],
  "state": {
    "title": "Shopping Cart",
    "spec": "Note that the shoppingcart will be a separate screen/activity, opened from var. menu icons (you can incl. one on inspiration fragment).",
    "ui": [
      {
        "title": "Screen",
        "spec": "",
        "events": [
          111
        ],
        "children": [
          {
            "title": "ToolBar",
            "children": [
              {
                "title": "DeleteAll Menu Icon",
                "spec": "Shown when: cart exists and cart state is not _preparing_;otherwise hidden  \\nclick->*105*",
                "events": [
                  105
                ],
                "states": [
                  {
                    "type": "attribute",
                    "title": "shown"
                  },
                  {
                    "type": "attribute",
                    "title": "hidden"
                  }
                ]
              }
            ]
          },
          {
            "title": "Content",
            "spec": "Default *Loading*  \\nWhen CartStore.stream cartOpt is present and cart.retailers are not empty: show *Filled*, otherwise, show *Empty*",
            "events": [
            ],
            "states": [
              {
                "type": "state",
                "title": "Loading",
                "images": [
                  "https://s3-eu-west-1.amazonaws.com/specdeck-mbb/UCO-Phone-LoadingCart.png"
                ]
              },
              {
                "title": "Empty Shopping Cart",
                "type": "state",
                "spec": "On xxx open deeplink on MainAct.  \\nOn yyy pass target to DeepLinkHelper.handleUniversalDeeplinks to open DealList",
                "images": [
                  "https://s3-eu-west-1.amazonaws.com/specdeck-mbb/UCO-Phone-EmptyCart-V1.png"
                ],
                "ui": [
                  {
                    "id": "ui1",
                    "title": "Button Main",
                    "spec": "On click, fire *100*",
                    "events": [
                      100
                    ]
                  },
                  {
                    "id": "ui2",
                    "title": "Button 1",
                    "spec": "Use targets: no 1  \\ntext= get display name for target  \\nOn click, fire *101* with target",
                    "events": [
                      101
                    ],
                    "attr": [
                      {
                        "name": "text",
                        "binding": "click target 1's name"
                      }
                    ],
                    "input": [
                      {
                        "type": "flow",
                        "id": 6
                      }
                    ]
                  },
                  {
                    "id": "ui3",
                    "title": "Button 2",
                    "spec": "Use targets: no 2  \\ntext= get display name for target  \\nOn click, fire *101* with target",
                    "events": [
                      101
                    ],
                    "attr": [
                      {
                        "name": "text",
                        "binding": "click target 2's name"
                      }
                    ],
                    "input": [
                      {
                        "type": "flow",
                        "id": 6
                      }
                    ]
                  },
                  {
                    "id": "ui4",
                    "title": "Button 3",
                    "spec": "Use targets: no 3  \\ntext= get display name for target  \\nOn click, fire *101* with target",
                    "events": [
                      101
                    ],
                    "attr": [
                      {
                        "name": "text",
                        "binding": "click target 3's name"
                      }
                    ],
                    "input": [
                      {
                        "type": "flow",
                        "id": 6
                      }
                    ]
                  },
                  {
                    "id": "ui5",
                    "title": "Button 4",
                    "spec": "Use targets: no 4  \\ntext= get display name for target  \\nOn click, fire *101* with target",
                    "events": [
                      101
                    ],
                    "attr": [
                      {
                        "name": "text",
                        "binding": "click target 4's name"
                      }
                    ],
                    "input": [
                      {
                        "type": "flow",
                        "id": 6
                      }
                    ]
                  }
                ],
                "flows": [
                  {
                    "id": 1,
                    "title": "Current gender",
                    "spec": "Get the current gender",
                    "input": [
                      {
                        "type": "global",
                        "id": 4
                      }
                    ],
                    "typesOutput": [
                      {
                        "id": 1,
                        "name": "Current Gender",
                        "type": "Gender"
                      }
                    ]
                  },
                  {
                    "id": 6,
                    "title": "Buttons to show",
                    "spec": "Based on selected gender,  \\nfor men:  \\n-Daunenjacken  \\n-High-Top Sneaker  \\n-Chinos  \\n-Sakkos  \\nfor women:  \\n-Schultertaschen  \\n-Abendkleider  \\n-Parkas  \\n-Stiefeletten",
                    "input": [
                      {
                        "type": "flow",
                        "id": 1
                      }
                    ],
                    "typesOutput": [
                      {
                        "id": 1,
                        "name": "List of click targets",
                        "type": "ClickTarget"
                      }
                    ]
                  },
                  {
                    "id": 2,
                    "title": "Create target category path",
                    "spec": "Convert input1 to its' ClickTarget",
                    "input": [
                      {
                        "type": "ui",
                        "id": 101
                      },
                      {
                        "type": "flow",
                        "id": 1
                      }
                    ],
                    "typesOutput": [
                      {
                        "id": 1,
                        "name": "Category Path",
                        "type": "CategoryPath"
                      }
                    ]
                  },
                  {
                    "id": 3,
                    "title": "Create MBB Shoppable target path",
                    "spec": "On 100 get selected gender id, then create DeepLinkTarget with pageType:DealList (use DeepLinkHelper.getIntForTargetPageType) with selected gender's catId as mainCatId and mbbCartShoppable set",
                    "input": [
                      {
                        "type": "ui",
                        "id": 100
                      },
                      {
                        "type": "flow",
                        "id": 1
                      }
                    ],
                    "typesOutput": [
                      {
                        "id": 1,
                        "name": "Category Path",
                        "type": "CategoryPath"
                      }
                    ]
                  },
                  {
                    "id": 4,
                    "title": "Create Product List target",
                    "spec": "Find sub cat ids for bags, etc.  \\nMerge(  \\n*101* map to bags-id  \\n*102* map to shoes-id  \\n*103* map to dresses-id  \\n*104* map to sneakers-id  \\n) -> get selected gender id,  \\nthen create DeepLinkTarget with pageType:DealList and DealFilter with sel gender id(i.e. main cat id) and sub cat id ",
                    "input": [
                      {
                        "type": "flow",
                        "id": 3
                      },
                      {
                        "type": "flow",
                        "id": 2
                      }
                    ],
                    "typesOutput": [
                      {
                        "id": 1,
                        "name": "Product List Target",
                        "type": "NavigationTarget"
                      }
                    ]
                  }
                ],
                "execs": [
                  {
                    "id": 5,
                    "title": "Open Deallist on top",
                    "spec": "On input1+2, launch a deallist for the specified target",
                    "input": [
                      {
                        "type": "flow",
                        "id": 4
                      }
                    ]
                  }
                ]
              },
              {
                "title": "Filled Shopping Cart",
                "type": "state",
                "images": [
                  "https://s3-eu-west-1.amazonaws.com/specdeck-mbb/UCO-Phone-FilledCart-Options.png"
                ],
                "spec": "Show Cart data: costs,etc",
                "ui": [
                  {
                    "title": "Shop Item in List",
                    "spec": "On underlined shop links clicks, fire *107* with respective shop host as id and link type.  \\nShow retailer data: label, total shipping costs (i.e.Versandkosten)",
                    "events": [
                      107
                    ],
                    "children": [
                      {
                        "title": "Product Item in List",
                        "spec": "On overflow delete menu item click, fire *108*.  \\nOn -/+ clicks, fire *109*.  \\n  \\nShow Cart Item data: brand, anem, sizes, price(s)",
                        "events": [
                          108,
                          109
                        ],
                        "children": [
                        ]
                      }
                    ]
                  },
                  {
                    "title": "Checkout Button",
                    "spec": "On click, fire *110*",
                    "events": [
                      110
                    ],
                    "children": [
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
}
`;



// WEBPACK FOOTER //
// ./src/components/shoppingcart.js